__turbopack_context__.v({
  "container": "wsI3-a_container",
  "text": "wsI3-a_text",
  "title": "wsI3-a_title",
});
